/**
 * 1stdibs
 * User: James
 * Date: 2/19/13
 */


/**
 * Base extension for Backbone.Collection, intended to
 * provide functionality common to all collections to
 * make working with 1stdibs services easier.
 *
 * @class SoaCollection
 * @extends Backbone.Collection
 *
 * @property {string} currentAction Defaults to 'fetch'
 * @property {boolean} cacheBust Defaults to false
 * @property {object} urls Defaults to an empty object empty
 * @property {number} totalResults
 *      Set by parse method and getTotalResultsForParams method
 *
 */
'use strict';

var Backbone = require('dibs-backbone');
var assign = require('lodash.assign');
var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var bunsenLib = require('bunsen/libraries/bunsen');

// ---------------------------------------------------
// Define Module Constructor Function

var SoaCollection = module.exports =  Backbone.Collection.extend({ constructor: function (models, options) {
    _.defaults(this, {
        params: {},
        defaultParams: {},
        urls: {},
        _urlArgs: [],
        options: options
    });
    Backbone.Collection.prototype.constructor.call(this, models, options);
}});

_.extend(SoaCollection.prototype, {
    currentAction: 'fetch',
    cacheBust:     false,


    /**
     * Used to reset the params object to the default state.
     * Also call this in your initialize to set any passed
     * params from options onto this.params.
     * @memberOf SoaCollection#
     */
    resetParams: function () {
        this.params = {};
        _.defaults(this.params, this.defaultParams);
        if (this.options && this.options.params) {
            _.extend(this.params, this.options.params);
        }
        this.trigger('SoaCollection:updateParams', [this]);
    },

    /**
     * Call this function to fetch data using the query params in
     * this.params.
     * @param {object} passedOptions
     *      passed to fetch. options.data will
     *      override parameters in this.params
     * @memberOf SoaCollection#
     * @returns {$.Deferred.promise}
     */
    fetchWithParameters: function (options) {
        options = assign({data: {}, reset: true}, options);
        options.data = assign({}, this.params, options.data);
        return this.fetch(options);
    },

    /**
     * Sets the param on the collection. Note* To remove the param pass a falsy "value" argument.
     * @param {string} param
     * @param {*} value
     */
    setParam: function (param, value) {
        var paramObj = {
            name:  param,
            value: value
        };

        if (value || value === 0) {
            this.params[param] = value;
            this.trigger('SoaCollection:addParam', paramObj, this);
        } else {
            delete this.params[param];
            this.trigger('SoaCollection:removeParam', paramObj, this);
        }

        this.trigger('SoaCollection:updateParams', this.params, this);
        return this;
    },

    /**
     * @memberOf SoaCollection#
     * @param {string} param
     * @returns {*}
     */
    getParam: function (param) {
        return this.params[param];
    },

    /**
     * @memberof SoaCollection
     * @returns the current url associated with the current action
     */
    url:   function () {
        if (typeof this.urls[this.currentAction] === 'function') {
            return this.urls[this.currentAction].apply(this, this._urlArgs);
        }
        return this.urls[this.currentAction];
    },
    /**
     * @memberOf SoaCollection#
     * @param {array}  [options]
     * @param {string} [actionName] - defaults to 'fetch'
     * @returns {$.Deferred.promise}
     */
    fetch: function (options, actionName) {
        this.currentAction = actionName || 'fetch';
        if (this.cacheBust) {
            options = options || {};
            options.data = _.extend(options.data || {}, {bypassCache: true, _t: new Date().getTime()});
        }
        return SoaCollection.__super__.fetch.call(this, options);
    },

    /**
     * @memberOf SoaCollection#
     * @param {string} method
     * @param {Backbone.Collection} collection
     * @param {object} passedOptions
     * @returns {$.Deferred.promise}
     */
    sync:  function (method, collection, passedOptions) {
        var tokenObj = this.getTokenObj();
        var options = passedOptions || {};

        // Append the user token to the URL.
        if (tokenObj) {
            if (method === 'read') {
                _.defaults(options, {data: {}});
                _.defaults(options.data, tokenObj);
            } else {
                options.url = bunsenLib.extendURL(options.url || _.result(collection, 'url'), tokenObj);
            }
        }
        return SoaCollection.__super__.sync.call(this, method, collection, options);
    },

    /**
     * Retrieves the token query params
     * object for the current user. If
     * no token object has been set, defers
     * to the bunsen.getToken function.
     * @return {object}
     */
    getTokenObj: function () {
        return this._tokenObject || bunsenLib.getToken();
    },

    /**
     * Sometimes the token needs to be set
     * manually, instead of relying on a
     * cookie. This can be done with this
     * method.
     * @param {string} token The user's token
     * @param {string} [key=userToken]
     *        The query param name for the token
     * @returns {SoaCollection}
     */
    setToken: function (token, key) {
        key = key || 'userToken';
        if (!token) {
            this._tokenObject = null;
            return this;
        }
        this._tokenObject = {};
        this._tokenObject[key] = token;
        return this;
    },


    /**
     * The parse function looks first to see if the response is an array, then it checks
     * to see if there is a 'result' attribute
     * for the row attribute inside of the returned response, disregarding the top level
     * attributes such as "created" and "totalSize"
     * @memberOf SoaCollection#
     *
     * @param data
     *
     * @returns {object}
     */
    parse: function (data) {
        var key;
        var keys;
        var l1Key;
        var l2Key;

        this.totalResults = null;

        if (!data) {
            return [];
        }
        if (_.isArray(data)) {
            return data;
        }

        // Total size of paginated list.
        if (_.isNumber(data.totalResults)) {
            this.totalResults = data.totalResults;
        }

        // If the collection is nested under an object called "result"
        if (data.result) {
            // Within the new service responses, lists come back serialized within `RESPONSE.result.dataList`
            //Removing apiType restriction - With Logistics, we get apiTypes like `shipmentQuotes`
            if (data.result.dataList) {// && data.result.apiType && data.result.apiType === 'list'
                return data.result.dataList;
            }
            if (_.size(data.result) === 1) {
                // Sometimes service responses are wrapped in an arbitrary wrapper object. If the collection array
                // is 2 levels below the "response" object - then fish it out. Otherwise return whatever is
                // directly under "response"
                l1Key = _.keys(data.result)[0];

                if (_.size(data.result) === 1 && ($.isPlainObject(data.result[l1Key])) && _.size(data.result[l1Key]) === 1) {
                    l2Key = _.keys(data.result[l1Key])[0];
                    return data.result[l1Key][l2Key];
                } else if (_.isObject(data.result[l1Key]) && _.isEmpty(data.result[l1Key])) {
                    //empty object means no results
                    return null;
                } else {
                    return data.result[l1Key];
                }
            } else {
                return data.result;
            }
        }
        // If the collection is under the "form" attribute (via the form service)
        if (data.form && data.formCode) {
            return data.form;
        }

        // If the collection is under the "row" attribute (query service)
        if (data.row) {
            return data.row;
        }
        keys = _.keys(data);
        key = keys.shift();
        while (key) {
            if (data[key] && data[key].row) {
                return data[key].row;
            }
            key = keys.shift();
        }
        return data;
    },

    /**
     * Filters the collection where, for the given field/property,
     * the model's value is in the given array
     *
     * @memberOf SoaCollection#
     * @param {string} field The name of a field
     * @param {array} arr An array of allowed values.
     * @param {boolean} [asJSON]
     *      True if return array of models should be in toJSON format
     * @returns {Backbone.Model[]|object[]}
     *      An array of models or and array of models as json
     */
    whereIn: function (field, arr, asJSON) {

        var whereArr = [];
        var models = this.models;
        var i = 0;
        var y;
        var yLen;
        var len = this.models.length;

        arr = _.isArray(arr) ? arr : [arr];
        yLen = arr.length;

        for (i; i < len; i++) {
            for (y = 0; y < yLen; y++) {
                if (models[i].attributes[field] === arr[y]) {
                    whereArr.push(asJSON ? models[i].toJSON() : models[i]);
                }
            }
        }

        return whereArr;
    },

    /**
     * Filters the collection where, for the given field/property,
     * the model's value is not in the given array
     *
     * @memberOf SoaCollection#
     * @param {String} field - The name of a field
     * @param {Array} arr - An array of allowed values.
     * @param {boolean} [asJSON] - True if return array of models should be in toJSON format
     * @returns {Backbone.Model[]|object[]}
     *      An array of models or and array of models as json
     */
    whereNotIn: function (field, arr, asJSON) {

        var whereNotArr = [];
        var models = this.models;
        var i = 0;
        var len = models.length;
        var isIn;
        var y;
        var yLen;

        arr = _.isArray(arr) ? arr : [arr];
        yLen = arr.length;

        for (i; i < len; i++) {
            isIn = false;
            for (y = 0; y < yLen; y++) {
                isIn = isIn || models[i].attributes[field] === arr[y];
            }
            if (!isIn) {
                whereNotArr.push(asJSON ? models[i].toJSON() : models[i]);
            }
        }

        return whereNotArr;
    },

    /**
     * Will pass the callback the total number of results the service has for provided params.
     * This is useful for bucketFilters which need to display the total results
     *
     * @param {object} passedParams Params to pass to the service as a query string
     * @param {function} callback Function to call when the results are known. totalResults is first and only argument
     * @param {object} options Additional options to pass to the fetchWithParameters request
     *
     * @return {$.Deferred}
     *      For some reason this function returns a deferred object instead of a promise
     */
    getTotalResultsForParams: function (passedParams, callback, options) {
        var params = passedParams || this.params;
        // create a new instance of the same collection we are
        var totalCollection = new SoaCollection();
        totalCollection.url = _.result(this, 'url');

        params = _.extend(bunsenLib.deepClone(params), {
            pageStart:          0,
            pageSize:           0,
            returnTotalResults: true
        });

        // Don't pass this in since it may filter results
        if (params.orderBy) {
            delete params.orderBy;
        }
        if (params.sort) {
            delete params.sort;
        }
        totalCollection.params = params;
        return $.when(totalCollection.fetchWithParameters(options)).then(function () {
            if (callback) {
                callback(totalCollection.totalResults);
            }
            return totalCollection.totalResults;
        });
    }
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/SoaCollection.js
// module id = 9
// module chunks = 62